module.exports = __webpack_public_path__ + "static/media/pathfinder.c9d92b90.jpg";